import React from 'react'
import { FieldProps, InteriorQualityString, InteriorQuality } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'
import { useTranslation } from 'react-i18next'

export interface InteriorQualityDropdownProps extends FieldProps<OtherFacilitiesScreenValidationResult> {
  wrapperClassName?: string
}

const InteriorQualityDropdown: React.FC<InteriorQualityDropdownProps> = ({
  insertionData,
  screenName,
  wrapperClassName = 'grid-item one-whole',
  onChange,
}) => {
  const { t } = useTranslation()

  const label = (
    <LabelWithTooltip
      inputId='interior-quality'
      labelText={t('wizard.screen.otherFacilities.interiorQuality', 'Interior Quality')}
      tooltipContent={<PopoverContent translationKey='wizard.screen.otherFacilities.interiorQualityPopover.content' />}
      showMandatory={false}
      arrowPosition='center'
      bodyPosition='top'
      containerClassName='margin-bottom-s'
    />
  )

  // Convert InteriorQualityString to dropdown options format
  const dropdownOptions = InteriorQualityString.map((quality) => ({
    value: quality,
    label: t(`wizard.screen.otherFacilities.${quality.toLowerCase()}`, quality),
  }))

  return (
    <div className={wrapperClassName}>
      {label}
      <DropdownSelect
        id='interior-quality'
        name='interiorQuality'
        value={insertionData.interiorQuality}
        noInformation={InteriorQuality.NO_INFORMATION}
        options={dropdownOptions}
        allowEmpty={true}
        errors={[]}
        onChange={(selectedOption) =>
          onChange({ screen: screenName, property: 'interiorQuality' }, selectedOption.value)
        }
      />
    </div>
  )
}

export default InteriorQualityDropdown
